
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/settings/general",
      function () {
        return require("private-next-pages/admin/settings/general.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/settings/general"])
      });
    }
  